import { DividerStyleModel } from '../../../Common/PageBuilder/models/divider-style.model';
import { StyleStateEnum } from '../../../Common/PageBuilder/enums/style-state.enum';
import { BriefingStyleStateEnum } from '../../../Common/MonitorShared/enum/briefing-style-state.enum';

export class MonitoringDividerStyleModel extends DividerStyleModel {
    constructor(apiModel?: any) {
        super(apiModel);
        if (!this.styleState || this.styleState === StyleStateEnum.DEFAULT) {
            this.styleState = BriefingStyleStateEnum.BRIEFING_1;
        }
        if (!this.displayStyleState || this.displayStyleState === StyleStateEnum.DEFAULT) {
            this.displayStyleState = this.styleState;
        }
        if (
            (
                !this.defaultReference ||
                this.defaultReference === StyleStateEnum.DEFAULT
            ) &&
            typeof this.styleState === 'string'
        ) {
            // Legacy data may not have default reference set, if the styleState is custom and there's no default reference, the default reference
            // should be BRIEFING_1 because it must have been created back when there was only one default
            this.defaultReference = this.styleState !== StyleStateEnum.CUSTOM ? this.styleState as string : BriefingStyleStateEnum.BRIEFING_1;
        }
    }
}
